// src/sim/ai/archetypes/constants.ts — Hider archetype utility weight constants (D-29..D-31).
// Source: .planning/phases/04-ai/04-CONTEXT.md D-29; 04-06-PLAN.md Task 1.
// TODO(P7 POL-06): retune from playtest.

/** Subtracts sighting-pressure in moveUtility — higher = movers avoid spotted zones more. */
export const P4_MOVE_AVOID_WEIGHT = 1.5;

/** Weight for caught-hider ratio in liberateUtility. */
export const P4_LIBERATE_CAUGHT_WEIGHT = 1.0;

/** Bonus for small-size characters in deepUtility (D-29). */
export const P4_DEEP_SMALL_SIZE_BONUS = 0.2;

/** Fear.dark penalty in deepUtility — dark-fearing characters hide less well in darkness. */
export const P4_DEEP_DARK_FEAR_PENALTY = 0.5;

/** Stamina weight in moveUtility. */
export const P4_MOVE_STAMINA_WEIGHT = 0.5;

/** hideSkill penalty in moveUtility — good hiders prefer to stay put.
 * TODO(P7 POL-06): retuned 2026-06-14 (D-11) 0.3 → 0.85. UAT (Group D5, 2026-06-12)
 * "AI hiders just random walk." The flat move courage bonus (+0.5) plus the sprint
 * term were swamping `deep` for high-hideSkill characters, so good hiders roamed
 * instead of hiding. This penalty scales with hideSkill, so raising it pulls `move`
 * below `deep` for skilled hiders WITHOUT touching low-hideSkill movers (whose
 * penalty term stays small) — archetype diversity preserved. See
 * .planning/todos/pending/2026-06-12-hider-archetype-rebalance.md. */
export const P4_MOVE_HIDE_SKILL_PENALTY = 0.85;

/** Fear threshold above which fallback-drop becomes active (FEAR-06). */
export const P4_HIDER_HIGH_FEAR_THRESHOLD = 0.5;
